import { mediaActionPath } from '@/common/app/path'
import { CitationStrategyAction } from '@/common/model/media/citation'
import { zeroPadding } from '@/common/util/number'

import TextButton from '@/components/view/atoms/button/TextButton'
import Heading from '@/components/view/atoms/heading/Heading'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import AiInsideArea from '@/components/view/layouts/area/AiInsideArea'
import Area from '@/components/view/layouts/area/Area'
import AreaContent from '@/components/view/layouts/area/AreaContent'

interface Props {
  actions: CitationStrategyAction[]
  siteId: number
  // 推奨アクション管理の絞り込みに使う分析ID
  historyId: number
}

// 戦略アクション1件（左＝戦略の概要／右＝具体アクション）
const ActionRow = ({ action, index }: { action: CitationStrategyAction; index: number }) => (
  <div className='grid grid-cols-1 items-center gap-2 lg:grid-cols-2'>
    <div className='border-ruri-600 bg-surface flex items-stretch overflow-hidden rounded-lg border p-1'>
      <div className='bg-fill-brand flex w-12 shrink-0 flex-col items-center justify-center gap-0.5 rounded-l-sm px-1 py-2'>
        <Text size={10} color={TextColor.ON_BG_FILL}>
          戦略
        </Text>
        <Text size={16} weight='bold' color={TextColor.ON_BG_FILL}>
          {zeroPadding(index + 1, 2)}
        </Text>
      </div>
      <div className='flex flex-1 flex-col gap-1 px-4 py-2'>
        <Text size={16} weight='bold'>
          {action.title}
        </Text>
        <Text size={14} lineHeight={150}>
          {action.background}
        </Text>
      </div>
    </div>
    <div className='flex items-center gap-0.5'>
      <div className='hidden shrink-0 px-1 lg:block'>
        <Icon type={IconType.MOVE_RIGHT} color={IconColor.PURPLE} size={24} />
      </div>
      <div className='min-w-0 flex-1'>
        <AiInsideArea>
          <div className='flex flex-col gap-1 px-2 py-1'>
            <div>
              <Text size={12} color={TextColor.AI} weight='bold'>
                具体アクション
              </Text>
            </div>
            <ol className='m-0 flex list-decimal flex-col gap-0.5 pl-5'>
              {(action.steps ?? []).map((step, i) => (
                <li key={i}>
                  <Text size={14} lineHeight={150}>
                    {step}
                  </Text>
                </li>
              ))}
            </ol>
          </div>
        </AiInsideArea>
      </div>
    </div>
  </div>
)

// 推奨アクション（AIが分析結果から生成した戦略アクション）
const CitationActionPanel = ({ actions, siteId, historyId }: Props) => (
  <Area bottomMargin={24}>
    <Heading
      subText={
        '言及元の傾向から優先度順に自動生成。実行・承認・自動化は推奨アクション管理で行います。'
      }
      rightNode={
        <TextButton link={mediaActionPath(siteId, { sourceAnalysisId: historyId })} arrow>
          推奨アクション管理
        </TextButton>
      }
    >
      {`推奨アクション ${actions.length}件`}
    </Heading>
    <AreaContent>
      <div className='flex flex-col gap-2'>
        {actions.map((action, i) => (
          <ActionRow key={i} action={action} index={i} />
        ))}
      </div>
    </AreaContent>
  </Area>
)

export default CitationActionPanel
